import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import useStyles from '../../../assets/styles/style';
import TestQuestionsHeading from './testQuestionsHeading';
import Config from '../../config/config';

const TestQuestionsMain = () => {
  const classes = useStyles(); 
  return (
    <div className={classes.formMainContainer}>
      <Box className={classes.formMainHeadingBox}>
        <TestQuestionsHeading />
      </Box>
      <Box component="main" className={classes.formMainBox}>
        <Paper className={classes.formMainpaper}>
        <Config />
        </Paper>
      </Box>
    </div>
  );
};

export default TestQuestionsMain;
